import React from "react"
import { HeroContainer, HeroWrapper, HeroText, HeroHead } from './HeroStyles'

const HeroContacts = ()=>{
    return(
        <>
        <HeroContainer>
            <HeroWrapper>
                <HeroText>
                    <HeroHead>Contacts</HeroHead>
                    
                </HeroText>
            </HeroWrapper>
        </HeroContainer>
        </>
    )
}

export default HeroContacts